/*
 * Project: Bookingengine
 * Module: PaymentUpfront.js
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';

import {
  BOOKING_STEP, createPaymentUpfront, setStep,
} from '../../../actions/Booking';

import PaymentLoading from './PaymentLoading';
import PaymentBooking from './PaymentBooking';
import PaymentBookDetails from './PaymentBookDetails';

import '../../../static/less/payment.less';
import { TPV_FORM_UPFRONT_PAYMENT_METHOD } from '../../../constants';
import withNavigate from '../../../withNavigate'; // Importa el HOC

class PaymentUpfront extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      hasError: false,
      bookingDetail: {},
    };
  }

  componentDidMount() {
    this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));

    const { lang, token } = this.props.params;
    if (lang && lang !== this.props.lang) {
      this.props.dispatch(setLanguage(lang));
    }

    this.props.dispatch(createPaymentUpfront(token, lang)).then(({ booking, hasError }) => {
      this.setState({
        isLoading: false,
        hasError,
        bookingDetail: booking,
      });
    });
  }

  canPayNow() {
    // Upfront payments are for confirmed bookings
    const { bookingDetail, isLoading, hasError } = this.state;
    if (isLoading || hasError) {
      return false;
    }
    return bookingDetail.status === 'CONF';
  }

  getErrorMessage() {
    if (this.state.hasError) {
      return this.context.t('Sorry, the payment upfront cannot be done now. Please try later');
    }
    return this.context.t('This booking cannot be paid upfront');
  }

  renderPaymentDetails() {
    const { bookingDetail } = this.state;
    if (this.canPayNow()) {
      return (
        <PaymentBooking formMethod={TPV_FORM_UPFRONT_PAYMENT_METHOD} booking={bookingDetail} lang={this.props.lang} />
      );
    }

    const currency = { ...bookingDetail.currency, locale: this.props.lang };
    return (
      <PaymentBookDetails booking={bookingDetail} currency={currency} errorMsg={this.getErrorMessage()} />
    );
  }

  render() {
    return (
      <div className="Payment">
        {this.state.isLoading ? <PaymentLoading /> : this.renderPaymentDetails()}
      </div>
    );
  }
}

PaymentUpfront.contextTypes = {
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
});

const ConnectedPaymentUpfront = connect(mapStateToProps)(PaymentUpfront);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedPaymentUpfront);
